'use strict';

(function () {
  'use strict';

  angular.module('msUtility').directive('svgIcon', svgIcon);

  svgIcon.$inject = ['$templateCache', '$log'];

  /* @ngInject */
  function svgIcon($templateCache, $log) {
    var directive = {
      link: link,
      restrict: 'E'
    };

    return directive;

    function link(scope, element, attrs) {
      attrs.$observe('iconId', function (iconId) {
        changeSvg(element, iconId);
      });
    }

    function changeSvg(element, iconId) {
      // This expects the icon to already be in $templateCache.
      var svgIcon = $templateCache.get(iconId + '.svg');
      if (svgIcon) {
        element.empty();
        element.append(svgIcon);
      } else {
        $log.error('SVG icon not found.', iconId, element);
      }
    }
  }
})();